module.exports = __webpack_public_path__ + "img/logo-salesflow.d31433df.png";